exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.h2_title[data-v-507b0ec5] {\n  font-weight: normal;\n}\n.icon[data-v-507b0ec5] {\n  background-color: #ffe800 !important;\n  color: black !important;\n  margin-left: -10px !important;\n  padding-right: 20px;\n}\n", ""]);

// exports
